import { useEffect } from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useServiceOptionsBase } from '../../service-dropdown/utils/use-service-options-base';
export const useServicesMultiChoiceOptions = props => {
  var _props$options;
  const {
    isLoading,
    options,
    isEmpty,
    shouldRender,
    setOptions,
    setIsEmpty,
    setHasInitialDataLoaded
  } = useServiceOptionsBase({
    fieldType: FIELD_TYPES.SERVICES_MULTI_CHOICE,
    isEditor: props.isEditor
  });
  const hasFullServiceData = (_props$options = props.options) == null ? void 0 : _props$options.every(option => option.label && option.id);

  // If we already have full service data, use it directly (override base hook behavior)
  useEffect(() => {
    if (hasFullServiceData && props.options) {
      setOptions(props.options);
      setIsEmpty(props.options.length === 0);
      setHasInitialDataLoaded(true);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFullServiceData, props.options, setOptions, setIsEmpty, setHasInitialDataLoaded]);
  return {
    isLoading,
    options,
    isEmpty,
    shouldRender
  };
};
//# sourceMappingURL=use-services-multi-choice-options.js.map